import { FC, useState } from 'react';
import { useSelector } from 'react-redux';
import { IntercomProvider } from 'react-use-intercom';
import { AppState } from '../../../store/AppState';
import { CurrentUser } from '../../../types/CurrentUser';
import Intercom from './Intercom';

type IntercomContainerProps = {
  isIntercomEnabled: boolean;
};

const IntercomContainer: FC<IntercomContainerProps> = ({ isIntercomEnabled }) => {
  const config = JSON.parse(localStorage.getItem('Config') as string);
  const INTERCOM_APP_ID = config?.intercomAppId;
  const interComLauncher = document.querySelector('.navbar-intercom');
  const [unreadMessagesCount, setUnreadMessagesCount] = useState(0);
  const { firstName, lastName, userName, dealerId, jobTitle, intercomUserHMAC } = useSelector<
    AppState,
    CurrentUser
  >((state) => state.currentUser);

  const onHide = (): void => {
    interComLauncher && interComLauncher.classList.remove('open');
  };

  const onShow = (): void => {
    interComLauncher && interComLauncher.classList.add('open');
  };

  const onUnreadCountChange = (amount: number) => {
    setUnreadMessagesCount(amount);
  };

  return (
    <>
      {isIntercomEnabled && (
        <IntercomProvider
          appId={INTERCOM_APP_ID}
          onHide={onHide}
          onShow={onShow}
          onUnreadCountChange={onUnreadCountChange}
          autoBoot={true}
          autoBootProps={{
            name: `${firstName} ${lastName}`,
            email: userName,
            userHash: intercomUserHMAC,
            customAttributes: {
              DealerId: dealerId,
              title: jobTitle,
            },
            customLauncherSelector: '.navbar-intercom',
            hideDefaultLauncher: true,
          }}
        >
          <Intercom unreadMessagesCount={unreadMessagesCount} />
        </IntercomProvider>
      )}
    </>
  );
};

export default IntercomContainer;
